import { Navigate, type RouteObject } from 'react-router';
import { RoutesList } from '../../config/routes-list';
import MainLayout from '../../layouts/MainLayout';
import { lazyRouteNamed } from '../lazy-route';

export const archiveRoutes: RouteObject[] = [
  {
    // Legacy URL: WhatsApp photos now live in the unified photo archive.
    path: RoutesList.ARCHIVE_WHATSAPP_PHOTOS,
    element: <Navigate to={`${RoutesList.ARCHIVE_GOODS_RECEIVING_PHOTOS}?type=whatsapp`} replace />,
  },
  {
    path: RoutesList.ARCHIVE_GOODS_RECEIVING_PHOTOS,
    element: <MainLayout />,
    children: [
      {
        index: true,
        ...lazyRouteNamed(
          () => import('../../pages/archive/photo-archive-page'),
          'PhotoArchivePage',
        ),
      },
    ],
  },
];
